module.exports = __webpack_public_path__ + "img/kp-hl.660306b2.png";